import { render, staticRenderFns } from "./NsModal.vue?vue&type=template&id=1c7f90d4&scoped=true&"
import script from "./NsModal.vue?vue&type=script&lang=js&"
export * from "./NsModal.vue?vue&type=script&lang=js&"
import style0 from "./NsModal.vue?vue&type=style&index=0&id=1c7f90d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7f90d4",
  null
  
)

export default component.exports